export const lang = {
	//titleชื่อเรื่องสําหรับแต่ละหน้า
	title: 'รายการผลิตภัณฑ์ร้านค้า',
}
